// import logo from './logo.svg';
import '../../App.scss';
import React, { useState, useEffect } from "react";
import Banner from './main-banner/Banner.js';
import Navbar from './header/Navbar.js';
import Farms from './farms/Farms.js';
import Loader from '../../shared/Loader.js';




function Landing() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0)
    setTimeout(() => {
      setLoading(false)
    }, 4000);
  }, [])


  return (
    <>
      {loading && <Loader/>}
      <Banner />
      <Farms/>
    </>
  );
}

export default Landing;